import HomeScreenContainer from "../../collections/HomeScreen/HomeScreenContainer"
import "./WazKBActivity.css"

type WazKBActivityProps = {

}

export const WazKBActivity = ({} : WazKBActivityProps) => {

    return (
        
        <div className="wazawan-home">
            {/* <WazToolbar /> */}
            <HomeScreenContainer />
        </div>
            
    )
}